<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="detailsForm">
    <form @submit.prevent="handleSubmit(submit)">
      <!-- Detalles de producción seleccionables -->
      <v-row v-if="canViewPrice && process.details.length > 0" class="my-0">
        <v-col
          v-for="(item, key) in process.details"
          :key="key.pk"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <!-- Subdetalles de producción -->
          <v-select
            v-if="item.subitems"
            item-text="name"
            item-value="pk"
            outlined
            clearable
            :disabled="readonly || belongsToOrder(item.pk, item.multi_choice)"
            :items="filterSubItems(item.pk)"
            :key="'select' + item.pk"
            :label="item.name"
            @change="openDetail('create', process.subdetail, item.pk)"
            v-model="process.subdetail"
          ></v-select>

          <!-- Detalles de producción -->
          <v-checkbox
            v-else
            class="v-switch mt-2"
            color="primary"
            name="hidden"
            :disabled="readonly || belongsToOrder(item.pk)"
            :input-value="belongsToOrder(item.pk)"
            :key="'switch' + item.pk"
            :label="item.name"
            @click="openDetail('create', item)"
          ></v-checkbox>
        </v-col>
      </v-row>

      <!-- Formulario de detalle de producción detallado -->
      <i-modal @submit="submit(modalAction)" v-model="dialog">
        <!-- Título y oculto -->
        <p class="details-by-order--title mb-0">{{ saleDetail.name }}</p>
        <div class="w-25">
          <v-switch
            class="v-switch mt-0"
            color="primary"
            key="hidden-input"
            name="hidden"
            :label="$tc('hide')"
            v-model="saleDetail.hidden"
          ></v-switch>
        </div>

        <!-- Detalles del item | Base -->
        <div v-if="saleDetail.price_type === 'base'">
          <i-money :label="$tc('price', 0)" v-model="saleDetail.price" />
        </div>

        <!-- Detalles del item | Fórmula -->
        <div v-if="saleDetail.price_type === 'formula'">
          <i-formula
            :key="saleDetail.pk"
            :cost="saleDetail.cost || 0"
            :defaultMeasure="defaultMeasure"
            :dimensions="saleDetail.have_dimensions ? dimensions : {}"
            :formula="saleDetail.formula"
            :measure="measure"
            :price="saleDetail.price || saleDetail.cost"
            :qty="qty"
            :readonly="readonly"
            :rootDimensions="saleDetail.pk ? {} : saleDetail.dimensions"
            :rounded="rounded"
            @change="managePrice"
            @changedimensions="saleDetail.dimensions = $event"
            v-model="saleDetail.priceString"
          />
        </div>

        <!-- Detalles del item | Matriz -->
        <div v-if="saleDetail.price_type === 'matrix'">
          <i-matrix
            hideSubtotal
            :subOrder="subOrder"
            :main_matrix="saleDetail.main_matrix"
            :matrixUse="'details'"
            :price="saleDetail.price"
            :priceString="saleDetail.priceString"
            :productId="saleDetail.product || subOrder.product"
            :detail="saleDetail"
            :detailId="saleDetail.detail || saleDetail.pk"
            :subdetailId="saleDetail.subdetail || null"
            :canViewCost="canViewCost"
            :qty="qty"
            @price="saleDetail.price = $event"
          />
        </div>
      </i-modal>

      <!-- Formulario de los detalles de producción ya asociados en la orden -->
      <h2 v-if="process.selected.length > 0">
        {{ $t('details_production') }}
        {{ canViewPrice ? `| ${$t('cumulative')}` : '' }}
      </h2>
      <div
        v-for="(item, index) in process.selected"
        :key="`${'fields'}-${index}`"
      >
        <div class="text-sumatory d-flex align-items-center g-2 mb-2">
          <p class="mb-0">
            &bull;
            {{ item.name }}
          </p>
          <span class="dotted-span"></span>
          <div v-if="canViewPrice">
            <i-money
              v-if="item.price_type !== 'bool'"
              mode="text"
              :value="item.price"
            />
            <v-btn
              class="px-2"
              color="primary"
              icon
              :disabled="item.price_type === 'bool' || readonly"
              @click="openDetail('edit', item)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              class="px-2"
              color="aux-text"
              icon
              :disabled="readonly"
              @click="hideDetail(item)"
            >
              <v-icon v-if="item.hidden" small>mdi-eye-off-outline</v-icon>
              <v-icon v-else small>mdi-eye-outline</v-icon>
            </v-btn>
            <v-btn
              class="px-2"
              color="error"
              icon
              :disabled="readonly"
              @click="remove(item)"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <p>
              {{ item.is_multipliable ? parseFloat(qty) : 1 }}
            </p>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    order: Number,
    readonly: {
      type: Boolean,
      default: false
    },
    measure: String,
    defaultMeasure: String,
    rounded: Boolean,
    qty: [Number, String],
    creatingDetail: {
      default: 1,
      type: Number
    },
    reload: {
      type: Boolean,
      default: false
    },
    subOrder: {
      type: Object
    },
    type_customer: {
      type: Number,
      default: 0
    },
    dimensions: {
      type: Object,
      default: () => {}
    },
    canViewPrice: {
      type: Boolean,
      default: false
    },
    canViewCost: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: null,
      loading: false,
      load: false,
      title: '',
      val: 1,
      dialog: false,
      process: {
        selected: [],
        details: [],
        subdetails: [],
        subdetail: null
      },
      saleDetail: {
        subOrder: '',
        pk: '',
        detail: '',
        subdetail: null,
        dimensions: {},
        priceString: '',
        formula: '',
        main_matrix: '',
        hidden: false,
        price: '',
        have_dimensions: ''
      },
      modalAction: 'edit'
    }
  },
  computed: {
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    }),
    orderDetails() {
      return {
        add: this.getPermissions([`sales.add_orderdetails`]),
        edit: this.getPermissions([`sales.change_orderdetails`]),
        delete: this.getPermissions([`sales.delete_orderdetails`])
      }
    }
  },
  watch: {
    reload(val) {
      if (val) {
        this.getSavedItems()
        this.$emit('update:reload', false)
      }
    },
    order: {
      immediate: true,
      handler() {
        this.getSavedItems()
      }
    }
  },
  methods: {
    ...mapActions({
      showConfirmation: 'confirmation/confirmationValue'
    }),
    getNameSelect(item) {
      return `${item.name} ${
        this.item.typeDetail === 'deliverytime' ? this.$t('days') : ''
      }`
    },
    /**
     * Método para consultar los procesos de producción (items) asociados a una
     * suborden de compra. En este método es donde se emiten los datos del
     * v-model detailPrices en DialogProduct
     *
     * @var process.selected: Items y subitems guardados en la suborden
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async getSavedItems() {
      let subtotal = []
      let response = await this.$api.suborder.production.show({
        pk: this.subOrder.pk,
        opt: {
          params: {
            subOrder: true
          }
        }
      })
      this.process.selected = response.data
      subtotal = response.data
      this.$emit('input', subtotal)
    },
    /**
     * Método para consultar los procesos de producción de un producto
     * y sus subprocesos (también llamados items y subitems respectivamente).
     *
     * @var process.details: Items del template del producto (es la copia del
     *                       template que se puede haber modificado - sin hijos)
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async getItems() {
      let subOrderProduct = this.subOrder.product
      try {
        let response = await this.$api.product.details.list({
          opt: {
            params: {
              product: subOrderProduct,
              order_by_process: true
            }
          }
        })
        this.process.details = response.data
        this.process.details.filter((item) => {
          if (item.subitems === true) {
            this.process.subdetails = [] // evita el overflow del copiado
            this.getSubItems(item.pk)
          }
        })
      } catch (error) {
        console.error('Error en la consulta getItems')
        console.error(error)
      }
    },
    /**
     * Método para consultar los subprocesos de producción (subitems) del
     * proceso de producción (item) al que pertenecen.
     *
     * @param itemPK: id del Item
     * @var process.subdetails: Subitems de los items del template del producto
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async getSubItems(itemPK) {
      let subitems = []
      try {
        let response = await this.$api.product.subdetails.list({
          opt: {
            params: {
              detail: itemPK
            }
          }
        })
        subitems = response.data.map((item) => {
          const currentPrice =
            item.product_prices.length > 0 &&
            item.product_prices.filter(
              (price) => price.level == this.subOrder.level
            )[0]
          return {
            ...item,
            price: currentPrice ? currentPrice.price : item.price
          }
        })
        this.process.subdetails = [...this.process.subdetails, ...subitems]
      } catch (error) {
        console.error('Error en la consulta de getSubItems')
        console.error(error)
      }
    },
    /**
     * Método para filtrar los subitems de procesos de producción por pk
     * del item al que pertenecen
     *
     * @param itemPK: id del Item
     * @returns filter: Array de subitems que le pertenecen al itemPK
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    filterSubItems(itemPK) {
      let filter = []
      filter = this.process.subdetails.filter((item) => item.item == itemPK)
      return filter
    },
    /**
     * Método para buscar un subitem de procesos de producción específico
     *
     * @param itemPK: id del Item
     * @returns {Array}: Array de subitems que le pertenecen al itemPK
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    getSingleSubitem(itemPK, subItemPK) {
      return this.process.subdetails.find(
        (item) => item.item === itemPK && item.pk === subItemPK
      )
    },
    /**
     * Método que comprueba si el proceso/subproceso de producción ya pertenece
     * a la suborden
     *
     * @param {number} itemPK     ID del item
     * @param {boolean} itemMulti Se puede seleccionar más de una opción
     *
     * @returns {boolean}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    belongsToOrder(itemPK, itemMulti = false) {
      if (itemPK && this.process.selected.length && !itemMulti) {
        return this.process.selected.some((event) => event.detail == itemPK)
      }
      return false
    },
    /**
     * Método que elimina un detalle de producción que pertenezca a una orden.
     *
     * @param {object} item - Objecto del detalle de producción a eliminar
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    remove(item) {
      this.title = item.name
      this.showConfirmation({
        show: true,
        model: this.$tc(this.title, 1),
        title: this.$tc('delete', 1),
        type: 'error white--text',
        content: this.$t('confirm_delete'),
        alert: `${this.$t('success', {
          model: this.$tc(this.title, 1),
          action: this.$tc('delete', 2)
        })}`,
        confirm: async () => {
          await this.$api.suborder.production.remove({ pk: item.pk })
          this.getItems()
          this.getSavedItems()
          this.$emit('update:reload', true)
          this.process.subdetail = null
        }
      })
    },
    /**
     * Calcula el subtotal de cada detalle de producción
     *
     * @param {Object} item
     * @returns {Number}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    subtotal(item) {
      if (item.is_multipliable) {
        return parseFloat(item.price) * parseFloat(this.qty)
      }
      return parseFloat(item.price)
    },
    /**
     * Método gestionar la modal lo que pasa con los detalles de producción.
     *
     * @param action {create, edit} Define la acción que hará la modal
     * @param item                  Datos del proceso o subproceso de producción
     * @param itemPK                ID del registro en caso que sea un
     *                              subproceso de producción
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async openDetail(action, item, itemPK = '') {
      // Inicializaciones importantes
      let price_type = ''
      this.modalAction = action

      // Inicialización del saleDetail al CREATE
      if (action === 'create') {
        if (itemPK) {
          let selectedSubitem = this.getSingleSubitem(itemPK, item)
          if (
            selectedSubitem.formula &&
            selectedSubitem.product_prices.length > 0
          ) {
            const activeProductPrice = selectedSubitem.product_prices.filter(
              (price) => price.level == this.subOrder.level
            )[0]
            selectedSubitem.price = parseFloat(activeProductPrice.price)
          }
          this.saleDetail = selectedSubitem
          this.saleDetail.subdetail = selectedSubitem.pk
          this.saleDetail.detail = selectedSubitem.item
          this.saleDetail.name = selectedSubitem.name
          price_type = selectedSubitem.price_type
        } else {
          this.saleDetail = item
          this.saleDetail.subdetail = null
          this.saleDetail.detail = item.pk
          this.saleDetail.name = item.name
          price_type = item.price_type
          if (price_type == 'formula' && item.product_prices.length > 0) {
            const activeProductPrice = item.product_prices.filter(
              (price) => price.level == this.subOrder.level
            )[0]
            this.saleDetail.price = parseFloat(activeProductPrice.price)
          }
        }
      }

      // Inicialización del saleDetail al EDIT
      if (action === 'edit') {
        this.saleDetail = item
        price_type = item.price_type
      }

      // Número de la orden
      this.saleDetail.subOrder = this.subOrder.pk

      // Detalles de producción tipo BOOL se guardan sin abrir la modal
      if (price_type === 'bool') {
        this.submit(this.modalAction)
      }

      // CREAR para todos los demás casos
      if (action === 'create' && price_type !== 'bool') {
        if (price_type === 'base') {
          this.submit(this.modalAction)
        } else {
          this.dialog = true
        }
      }

      // EDITAR para todos los demás casos
      if (action === 'edit' && price_type !== 'bool') {
        this.dialog = true
      }
    },
    /**
     * Método para determinar si al enviar el formulario de la modal, este debe
     * crear un nuevo registro o editar uno exisitente.
     *
     * @param {String} action   Determina la acción que realizará. Tiene dos
     *                          modos posibles, -create- y -edit-, donde edit
     *                          es el modo por defecto en caso de no enviar el
     *                          parámetro.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    submit(action = 'edit') {
      if (action === 'create') {
        this.createDetail()
      }
      if (action === 'edit') {
        this.editDetail()
      }
    },
    /**
     * Método para guardar el detalle/subdetalle de producción en la orden de
     * venta.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async createDetail() {
      try {
        await this.$api.suborder.production.create({
          form: this.saleDetail,
          opt: {
            params: {
              level: this.subOrder.level
            }
          }
        })
        this.$toast.success(
          `${this.$tc(this.title, 1)} ${this.$tc(
            this.saleDetail.pk !== undefined ? 'edited' : 'created',
            2
          )}`
        )
      } catch (error) {
        console.error('Error en createDetail')
        console.error(error)
      } finally {
        this.getSavedItems()
        this.dialog = false
      }
    },
    /**
     * Método para modificar un detalle de producción ya asociado a la orden de
     * venta.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async editDetail() {
      try {
        await this.$api.suborder.production.edit({
          pk: this.saleDetail.pk,
          form: this.saleDetail
        })
        this.$toast.success(
          `${this.$tc('details_production', 1)} ${this.$tc('edited', 2)}`
        )
      } catch (error) {
        console.error('Error en el submit del detailsByOrder')
        console.error(error)
      } finally {
        this.getSavedItems()
        this.dialog = false
      }
    },
    /**
     * Método para ocultar/mostrar un detalle de producción ya asociado a la
     * orden de venta
     * @param item    Datos del detalle o subdetalle de producción ya asociado
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    async hideDetail(item) {
      item.hidden = !item.hidden || false
      try {
        await this.$api.suborder.production.edit({
          pk: item.pk,
          form: item
        })
        this.$toast.success(
          `${this.$tc('details_production', 1)} ${this.$tc('edited', 2)}`
        )
      } catch (error) {
        console.error('Error en el submit del hideDetail')
        console.error(error)
      } finally {
        this.getSavedItems()
        this.dialog = false
      }
    },
    /**
     * Método para cambiar el precio asociado al detalle de producción o
     * subdetalle de producción.
     * @param val    Valor del precio
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    managePrice(val) {
      if (Number.parseFloat(val) >= 0) {
        this.saleDetail.price = Number.parseFloat(val)
      }
    }
  },
  created() {
    this.unwatch = this.$store.watch(
      () => this.$store.getters['confirmation/getConfirmationFinished'],
      async (val) => {
        if (val === this.title || !val) {
          this.getItems()
          this.getSavedItems()
          this.deleting = false
          this.$store.dispatch('confirmation/confirmationFinished', false)
        }
      }
    )
  },
  mounted() {
    this.getItems()
    this.getSavedItems()
  },
  beforeDestroy() {
    this.unwatch()
  }
}
</script>
<style lang="sass">
.details-by-order--title
  // Título de cada detalle de producción
  font-size: 1rem
  line-height: 1.3rem
  font-weight: bolder
  @media (width >= 600px)
    font-size: 1.25rem
    line-height: 2rem
.details-by-order--item
  // Container de cada detalle de producción
  padding: 12px
  border-radius: 8px
  margin-bottom: 12px
  display: flex
  flex-direction: column
  height: fit-content

.details-by-order--header
  // Header de cada detalle de producción
  display: flex
  width: 100%
  justify-content: space-between
  align-items: center

.theme--light
  .dialog-product--modal-second-step
    .details-by-order--item
      background-color: rgb(0 0 0 / 5%)
      .details-by-order--title
        color: #616161

.theme--dark
  .dialog-product--modal-second-step
    .details-by-order--item
      background-color: rgb(255 255 255 / 5%)
      .details-by-order--title
        color: #e0e0e0
</style>
